import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import valueEmitterPropTypes from 'core/utils/prop-types/value-emitter';

/**
 * Компонент используемый для множественной подписки
 * на событие `onChangeClientState` в либе `react-helmet`.
 *
 * Из-за https://github.com/nfl/react-helmet/issues/328 использовать этот пропс
 * на самом компоненте `Helmet` нельзя так как это приведет к перезаписыванию
 * других обработчиков. Поэтому мы реализовали в качестве ad-hoc решения свою
 * очередь обработчиков (см. компонент `App`).
 *
 * @author Anton Ignatov <a.ignatov@rambler-co.ru>
 */
export default class HelmetStateChange extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };

  static contextTypes = {
    helmetOnChangeEmitter: valueEmitterPropTypes,
  };

  componentDidMount() {
    const { helmetOnChangeEmitter } = this.context;
    this.unsubscribe = helmetOnChangeEmitter.subscribe(this.onChange);
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe();
  }

  onChange = newState => {
    const { onChange } = this.props;
    if (onChange) onChange(newState);
  };

  render() {
    return this.props.children;
  }
}
